import { Base } from "../../../../base/components/base"
import { rateThStyle } from "./rate-th.style"

export const RateTh = (title?: string) => {

    const base = Base('th')
    base.cssClass(rateThStyle)

    if (title !== undefined && title !== null) {
        base.el.textContent = title
    }

    return base
}